import { getRequests, setRequestState } from '@/api/requests'
import '@/utils/types.js'
import { stateEnum } from '@/constants'

/**
 * @returns {
 *  requests: RequestShort[]
 *  drafts: RequestShort[]
 * }
 */
const state = () => ({
  requests: [],
  requestsTotal: 0,
  requestsStatus: 'loading',
})

const mutations = {
  setStateProps(state, payload) {
    state[payload.prop] = payload.value
  },
  patchRequestState(state, payload) {
    state.requests[payload.id].state = payload.state
  },
}

const actions = {
  /**
   * @param {import('vuex').ActionContext} context
   * @param {{limit?: number, offset?: number}} params
   */
  async fetchRequests({ commit }, params) {
    try {
      commit('setStateProps', {
        prop: 'requestsStatus',
        value: 'loading',
      })

      const newParams = { ...params }
      if (!newParams.states) {
        const allStates = Object.keys(stateEnum).filter(
          (e) => !['draft', 'completed', 'rejected'].includes(e)
        )
        newParams.states = allStates
      }

      const response = await getRequests(newParams)

      commit('setStateProps', { prop: 'requests', value: response.requests })
      commit('setStateProps', {
        prop: 'requestsStatus',
        value: 'succeed',
      })
      commit('setStateProps', {
        prop: 'requestsTotal',
        value: response.total || 0,
      })
    } catch (error) {
      commit('setStateProps', {
        prop: 'requestsStatus',
        value: 'failed',
      })
      commit('setStateProps', {
        prop: 'requests',
        value: [],
      })
      commit('setStateProps', {
        prop: 'requestsTotal',
        value: 0,
      })
      throw new Error(error)
    }
  },
  /**
   * @param {import('vuex').ActionContext} context
   * @param {{requestId: number, method: RequestStateMethods}} params
   * @param {{comment?: string}} [data]
   */
  async changeRequestState(
    { state, dispatch, commit },
    params,
    data = { comment: 'Изменение статуса заявки' }
  ) {
    try {
      const updatedRequest = await setRequestState(params, data)
      const updatedRequestIdx = state.requests.findIndex(
        (r) => r.id === updatedRequest.id
      )
      if (~updatedRequestIdx) {
        commit('patchRequestState', {
          id: updatedRequestIdx,
          state: updatedRequest.state,
        })
      }
    } catch (error) {
      dispatch('showError', error, { root: true })
    }
  },
}

export default {
  state,
  actions,
  mutations,
  namespaced: true,
}
